import React, { useEffect, useState } from "react";
import ProviderContainer from "../../components/ProviderContainer";

import hospitalsData from "../../components/data/hospitalsData.json";
import clinicsData from "../../components/data/clinicsData.json";
import dentalClinicsData from "../../components/data/dentalClinicsData.json";

import NoRecords from "../../components/NoRecords";

const ProviderMasterlist = ({
  cityCode,
  providerType,
  setIsModalActive,
  setModalProps,
}) => {
  const activeProvider = [];
  const [isNoDataPulled, setIsNoDataPulled] = useState(false);

  useEffect(() => {
    if (
      activeProvider.length > 0 ||
      activeProvider === null ||
      activeProvider === "undefined"
    ) {
      setIsNoDataPulled(false);
    } else {
      setIsNoDataPulled(true);
    }
  }, [activeProvider]);

  const Container = () => {
    if (isNoDataPulled) {
      return <NoRecords isShow={isNoDataPulled} />;
    } else {
      if (providerType === "H") {
        return (
          <>
            {hospitalsData
              .filter((providerDetail, index) => {
                if (cityCode === providerDetail.citycode) {
                  activeProvider.push(providerDetail);
                  return providerDetail;
                }
              })
              .map((providerDetail, index) => {
                return (
                  <ProviderContainer
                    title={providerDetail.providername}
                    maindesc={providerDetail.streetaddress}
                    desc={providerDetail.coordinator}
                    footer={providerDetail.telephone}
                    key={`hosp_${index + 1}`}
                    customParams={{
                      setIsModalActive: setIsModalActive,
                      setModalProps: setModalProps,
                      props: providerDetail,
                    }}
                  />
                );
              })}
          </>
        );
      } else if (providerType === "C") {
        return (
          <>
            {clinicsData
              .filter((providerDetail, index) => {
                if (
                  cityCode === providerDetail.citycode &&
                  providerDetail.providertypedesc === providerType
                ) {
                  activeProvider.push(providerDetail);
                  return providerDetail;
                }
              })
              .map((providerDetail, index) => {
                return (
                  <ProviderContainer
                    title={providerDetail.providername}
                    maindesc={providerDetail.streetaddress}
                    desc={providerDetail.coordinator}
                    footer={providerDetail.telephone}
                    key={`hosp_${index + 1}`}
                    customParams={{
                      setIsModalActive: setIsModalActive,
                      setModalProps: setModalProps,
                      props: providerDetail,
                    }}
                  />
                );
              })}
          </>
        );
      } else {
        return (
          <>
            {dentalClinicsData
              .filter((providerDetail, index) => {
                if (cityCode === providerDetail.citycode) {
                  activeProvider.push(providerDetail);
                  return providerDetail;
                }
              })
              .map((providerDetail, index) => {
                return (
                  <ProviderContainer
                    title={providerDetail.providername}
                    maindesc={providerDetail.streetaddress}
                    desc={providerDetail.coordinator}
                    footer={providerDetail.telephone}
                    key={`hosp_${index + 1}`}
                    customParams={{
                      setIsModalActive: setIsModalActive,
                      setModalProps: setModalProps,
                      props: providerDetail,
                    }}
                  />
                );
              })}
          </>
        );
      }
    }
  };

  return <Container />;
};

export default ProviderMasterlist;
